import { Typography } from '@material-ui/core';
import React from 'react';

import { publicaColors } from '~/src/dash/utils/colors';
import { IMeasurementBreadCrumb } from '~/src/dash/views/measurement/common/types';

interface IMeasurementBreadCrumbsProps {
  crumbs: IMeasurementBreadCrumb[];
  handleBreadCrumbClick: (crumb: IMeasurementBreadCrumb) => void;
  handleBreadCrumbClear: () => void;
}

export const IMeasurementBreadCrumbs = ({
  crumbs,
  handleBreadCrumbClick,
  handleBreadCrumbClear,
}: IMeasurementBreadCrumbsProps) => {
  const breadCrumbs: any = [];
  crumbs.map((crumb, i) => {
    breadCrumbs.push(
      <>
        <span
          onClick={() => handleBreadCrumbClick(crumb)}
          style={{
            cursor: 'pointer',
            color: publicaColors.blue,
            fontWeight: 500,
          }}
        >
          {crumb.groupByLabel}
        </span>
        {i !== crumbs.length - 1 ? (
          <span style={{ fontWeight: 500 }}>{` / `}</span>
        ) : (
          <span>{` / ${crumb.label}`}</span>
        )}
      </>,
    );
  });
  return (
    <Typography style={{ fontSize: 14 }}>
      {breadCrumbs}
      <span
        onClick={handleBreadCrumbClear}
        style={{
          color: publicaColors.blue,
          cursor: 'pointer',
          paddingLeft: 16,
        }}
      >
        Clear
      </span>
    </Typography>
  );
};
